import React, { useState } from "react";
import { Menu, Dropdown, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons"; // Import the calendar icon

interface AppFilterProps {
  value: string; // Current value passed from parent
  onChange: (value: string) => void; // Function to send selected value to parent
}

const DashboardDateFilter: React.FC<AppFilterProps> = ({ value, onChange }) => {
  const [selectedValue, setSelectedValue] = useState<string>(value); // Local state to track selection

  const handleMenuClick = (e: any) => {
    const newValue = e.key; // Get the selected menu item key
    setSelectedValue(newValue); // Update the local state
    onChange(newValue); // Send the new value back to the parent
  };
  const keyMap: any = {
    "7": "Past 7 days",
    "14": "Past 14 days",
    "30": "Past 1 month",
    "90": "Past 3 months",
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="7">Past 7 days</Menu.Item>
      <Menu.Item key="14">Past 14 days</Menu.Item>
      <Menu.Item key="30">Past 1 month</Menu.Item>
      <Menu.Item key="90">Past 3 months</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <Button type="text">
        {keyMap[selectedValue] || "Past 7 days"} <CalendarOutlined />{" "}
        {/* Display selected value */}
      </Button>
    </Dropdown>
  );
};

export default DashboardDateFilter;
